var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmileySad = function SvgSmileySad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 67.7916C54.1773 67.7916 67.2916 54.6773 67.2916 38.5C67.2916 22.3226 54.1773 9.20831 38 9.20831C21.8226 9.20831 8.70831 22.3226 8.70831 38.5C8.70831 54.6773 21.8226 67.7916 38 67.7916Z",
    stroke: "#5768FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.985 51.5149C25.5233 50.8182 30.2733 44.9599 38.4117 44.9916C46.2333 45.0549 50.825 50.5333 51.4267 51.2933",
    stroke: "#5768FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.11 32.1667C23.11 30.2552 24.662 28.6766 26.6 28.6766C28.5379 28.6766 30.09 30.2552 30.09 32.1667C30.09 34.0781 28.5379 35.6567 26.6 35.6567C24.6911 35.6567 23.11 34.0755 23.11 32.1667Z",
    fill: "#5768FF",
    stroke: "#5768FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.91 32.1667C45.91 30.2552 47.4621 28.6766 49.4 28.6766C51.3089 28.6766 52.89 30.2578 52.89 32.1667C52.89 34.0781 51.3379 35.6567 49.4 35.6567C47.4911 35.6567 45.91 34.0755 45.91 32.1667Z",
    fill: "#5768FF",
    stroke: "#5768FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmileySad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smiley-sad.3e5060d4.svg";
export { ForwardRef as ReactComponent };